import moment from "moment";
import axios from "axios";
import Utils from "../../Utils";
import _ from "lodash";

const DiscussionItem = ({ psdetails, data }) => {
  const fileUrl = data.filename
    ? `${process.env.REACT_APP_API_URL}/uploads/photoshoot_attachments/${data.filename}`
    : null;

  const downloadAttachment = (discussion) => {
    axios
      .get(
        Utils.apiUrl(`photoshoot/attachment/discussion/file/${discussion.id}`),
        {
          responseType: "arraybuffer", // Important for binary data
          ...Utils.apiHeaders(),
        },
      )
      .then((res) => {
        console.log(res.data);

        // Convert buffer data into file
        const bufferData = res.data;

        // Convert to Uint8Array
        const byteArray = new Uint8Array(bufferData);

        // Create a Blob (set correct MIME type from response headers)
        const blob = new Blob([byteArray], {
          type: res.headers["content-type"] || "application/octet-stream",
        });

        // Get filename from headers or default
        const contentDisposition = res.headers["content-disposition"];
        //const filename = contentDisposition
        //    ? contentDisposition.split('filename=')[1]?.replace(/"/g, '') || `attachment_${attachment.id}`
        //    : `attachment_${attachment.id}`;

        const filename = discussion.filename;

        // Create download link
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();

        // Cleanup
        URL.revokeObjectURL(url);
        document.body.removeChild(a);
      })
      .catch((err) => {
        console.error("Download failed:", err);
        alert("Failed to download attachment");
      });
  };

  const bgUserTypeColor = (utype) => {
    const bg = {
      HR: "#258b85",
      PG: "#f5bb48",
      BT: "#466ff7",
    };
    return bg[utype] || "#6b7280";
  };

  const getPosterName = (utype) => {
    if (utype === "HR") return psdetails?.hrname || "Hotel Photography Lead";
    if (utype === "PG") return psdetails?.pgname || "Photographer";
    if (utype === "BT") return "Brand Team";
    return "User";
  };

  const getPosterType = (utype) => {
    if (utype === "HR") return "HP";
    if (utype === "AMT") return "AM";
    return utype.toUpperCase();
  };

  return (
    <div className="bg-white p-3 rounded border flex gap-3">
      {/* Circle Avatar */}
      <div
        className="w-6 h-6 rounded-full text-white flex items-center justify-center text-xs font-bold shrink-0"
        style={{
          backgroundColor: bgUserTypeColor(data.usertype),
        }}
        title={`Posted by ${getPosterName(data.usertype)}`}
      >
        {getPosterType(data.usertype)}
      </div>

      {/* Content */}
      <div className="flex-1">
        <div className="text-sm text-gray-800">{data.comment}</div>

        {fileUrl && (
          <button
            onClick={() => downloadAttachment(data)}
            className="text-blue-600 text-sm flex items-center gap-1 mt-1"
          >
            <i className="fas fa-paperclip"></i>
            {data.filename}
          </button>
        )}

        <div className="text-xs text-gray-400 mt-1">
          {moment(data.created_at).fromNow()} by {getPosterName(data.usertype)}
        </div>
      </div>
    </div>
  );
};

export default DiscussionItem;
